import { lazy, Suspense, useEffect, useState } from 'react'
import { App } from './app/App'

const MultiplayerApp = lazy(() =>
  import('./multiplayer/MultiplayerApp').then((module) => ({ default: module.MultiplayerApp })),
)

function normalizedPathname(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
}

export function RootApp() {
  const [pathname, setPathname] = useState(() => normalizedPathname(window.location.pathname))
  useEffect(() => {
    const update = () => setPathname(normalizedPathname(window.location.pathname))
    window.addEventListener('popstate', update)
    return () => window.removeEventListener('popstate', update)
  }, [])
  return pathname === '/multiplayer' ? (
    <Suspense fallback={<div role="status">Loading multiplayer grid…</div>}>
      <MultiplayerApp />
    </Suspense>
  ) : (
    <App />
  )
}
